import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getActiveBenefits } from '@epi-actions/api';
import { fetchGet } from '@epi-helpers/FetchHelpers';
import { companyBenefitGroupSettingsActiveBenefitsUrl } from '@epi-repositories/BenefitGroupSettingsRepository';
import { showNotification } from '@epi-actions/overlays';
import { IBenefits } from '@epi-models/containers/ManageBenefits';
import { getOnboardingLoadBenefitPageType } from '@epi-store/onboarding/onboarding.selectors';
import { useOnboardingWizard } from '@epi-shared/hooks';
import { LoadBenefitPageTypes } from '@epi-constants/onboardingTypes';
import { BenefitType } from '@epi-constants/benefitTypes';

export const useTopup = () => {
  const dispatch = useDispatch();
  const { isOnBoardingActive } = useOnboardingWizard();
  const onboardingPageType = useSelector(getOnboardingLoadBenefitPageType);

  const [isLoading, setIsLoading] = useState(true);
  const [activeBenefits, setActiveBenefits] = useState<never[] | IBenefits[]>(
    []
  );

  const sortBenefitsInOrder = (benefits: IBenefits[]): IBenefits[] => {
    const orderMap = {
      lunch: 1,
      recreational: 2,
      transport: 3,
      massage: 4,
      wellbeing: 5
    };

    return [...benefits]
      .map(elem => elem.toLowerCase())
      .sort((a, b) => {
        const orderA = orderMap[a] || 999;
        const orderB = orderMap[b] || 999;
        return orderA - orderB;
      }) as IBenefits[];
  };

  const onSuccess = res => {
    setActiveBenefits(sortBenefitsInOrder(res));
    setIsLoading(false);
  };

  const onFailure = () => {
    dispatch(showNotification({ message: 'messages.error' }, 'error'));
    setIsLoading(false);
  };

  useEffect(() => {
    dispatch(getActiveBenefits());
  }, []);

  useEffect(() => {
    fetchGet(
      companyBenefitGroupSettingsActiveBenefitsUrl,
      {},
      onSuccess,
      onFailure
    );
  }, []);

  const filterBenefits = (benefits: IBenefits[]) => {
    if (!isOnBoardingActive) {
      return benefits;
    }
    if (onboardingPageType === LoadBenefitPageTypes.Lounari) {
      return benefits.filter(benefit => benefit === BenefitType.Lunch);
    }
    if (onboardingPageType === LoadBenefitPageTypes.Others) {
      return benefits.filter(benefit => benefit !== BenefitType.Lunch);
    }

    return benefits;
  };

  const returnedBenefits = filterBenefits(activeBenefits);

  return {
    hasLoadableBenefit: !!returnedBenefits.length,
    isLoading,
    activeBenefits: returnedBenefits
  };
};
